import React from 'react';
import { Route } from 'react-router-dom';
import { withStyles, Typography } from './../../../themes/default';

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1,
    background: theme.palette.grey[100]
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
});

const Layout = ({children, classes, ...rest}) => {
  return (
    <Typography component="div" className={ classes.root }>
      <div className={ classes.container }>
        { children }
      </div>
    </Typography>
  )
}

const LoginLayout = ({ component: Component, ...rest }) => {
  return (
    <Route { ...rest } render={ matchProps => (
      <Layout classes={ rest.classes }>
          <Component { ...matchProps } />
      </Layout>
    )} />
  )
};

export default withStyles(styles)(LoginLayout);
